import { isCorpTenant } from "@capone/common";
import {
  BusinessModalNames,
  CorpBusinessAccount,
  CorpSessionInfo,
  CustomerAccountRole,
  ModalDataMap,
  PolicyTier,
  RewardsAccount,
  SessionInfo,
  Tenant,
} from "redmond";
import { getIsDefaultPolicySelected } from "./getIsDefaultPolicySelected";
import { getUserDeviceData } from "./userDeviceHelper";

type StoreState<T extends Tenant> = {
  sessionInfo?: T extends "capone-corporate" ? CorpSessionInfo : SessionInfo;
  corpBusinessAccounts?: CorpBusinessAccount[];
  rewardsAccounts?: RewardsAccount[];
  selectedAccountReferenceId?: string | null;
  policyTier?: PolicyTier;
  modalMetadata?: { [K in BusinessModalNames]?: ModalDataMap[K] } | null;
};

const getCorpUserSessionData = (
  state: StoreState<"capone-corporate">,
  customerAccountRole?: CustomerAccountRole
) => {
  const {
    sessionInfo,
    corpBusinessAccounts = [],
    modalMetadata,
    policyTier,
  } = state;

  const approvalProcess =
    policyTier?.settings?.isApprovalRequired === true ? "24hr_review" : "auto";

  return {
    business_id: sessionInfo?.corporateInfo.businessId,
    business_name: sessionInfo?.corporateInfo.businessName,
    customer_account_role:
      customerAccountRole || sessionInfo?.corporateInfo?.cap1Role,
    user_role: sessionInfo?.corporateInfo.role?.join(","),
    user_policy_tier: sessionInfo?.corporateInfo.policyTier,
    user_approval_process: approvalProcess,
    num_eligible_businesses: corpBusinessAccounts.length.toString() || 0,
    num_optedin_businesses:
      corpBusinessAccounts
        .filter((account) => "optedIn" in account)
        .length.toString() || 0,
    whos_booking_answer: modalMetadata?.whos_booking?.answer,
    user_policy_active: !getIsDefaultPolicySelected(policyTier),
  };
};

export const getGlobalTrackingProperties = <T extends Tenant>(
  tenant: T,
  state: StoreState<T>
) => {
  const { rewardsAccounts = [], selectedAccountReferenceId } = state;

  const currentRewardsAccount = rewardsAccounts.find(
    (account) => account.accountReferenceId === selectedAccountReferenceId
  );
  return {
    customer_account_role: currentRewardsAccount?.customerAccountRole,
    product: currentRewardsAccount?.productDisplayName,
    currency: currentRewardsAccount?.rewardsBalance.currency,
    ...getUserDeviceData(),
    ...(isCorpTenant(tenant) &&
      getCorpUserSessionData(
        state as StoreState<"capone-corporate">,
        currentRewardsAccount?.customerAccountRole
      )),
  };
};
